import styled from 'styled-components';

export const SectionHeadline = styled.div`
  position: relative;
  text-align: center;
  justify-content: center;

  .arrow {
    svg {
      width: 0.875rem;
      fill: black;
    }
  }

  &[dir='ltr'] {
    .arrow {
      svg {
        margin-left: 5px;
      }
    }
  }

  &[dir='rtl'] {
    .arrow {
      svg {
        margin-right: 5px;
      }
    }
  }

  &.newdevelopment {
    margin: 0px;
    h2 {
      @media (max-width: 991.98px) {
        margin-bottom: 0;
        padding: 1.5rem 0;

        &[dir='ltr'] {
          text-align: left;
        }

        &[dir='rtl'] {
          text-align: right;
        }
      }
    }
    span {
      @media (max-width: 767.98px) {
        display: none;
      }
    }
  }

  &.venueorganise_heading {
    margin: 0;
    text-align: center;

    @media (max-width: 575px) {
      justify-content: center;
    }

    h2 {
      margin: 0 0 1.5rem;

      @media (max-width: 1199.98px) {
        font-size: 26px;
      }

      @media (max-width: 767.98px) {
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 1rem;
      }
    }
  }

  &.section_caption {
    @media (max-width: 767.98px) {
      text-align: left;
      padding: 0px 7px;
    }
  }

  &.latest_news_caption {
    @media (max-width: 767.98px) {
      margin: 24px 0 0;
      text-align: center;
      justify-content: center;

      h2 {
        margin-bottom: 10px;
        line-height: 60px;
      }
    }
  }

  &.event_slider_cap {
    @media (max-width: 767.98px) {
      padding-right: ${({ dir }) => (dir === 'rtl' ? '' : '20px')};
      margin-bottom: 2rem !important;
      padding-left: 0px;
      line-height: 60px;
    }

    @media (max-width: 575.98px) {
      margin: 0px 30px;
      display: flex;
      justify-content: flex-start;
    }
  }

  @media (min-width: 575px) {
    margin: 1.5rem 0 70px;
  }

  @media (max-width: 575.98) {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: start;
  }

  h2 {
    &.title_sm {
      font-size: 20px;
      line-height: 30px;
      color: #000;

      & + p {
        display: block;
        @media (max-width: 767.98px) {
          display: block;
        }
      }
    }

    color: #4a4a4a;

    @media (max-width: 767.98px) {
      padding-right: ${({ dir }) => (dir === 'rtl' ? '' : '20px')};
      line-height: 30px;
      margin-bottom: 0rem;
      font-size: 20px;
    }
  }

  p {
    color: #898989;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1.5rem;

    @media (max-width: 767.98px) {
      display: none;
    }
  }

  h3 {
    font-size: 20px;
  }

  a {
    font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '12px')};
    letter-spacing: 2.18px;
    text-transform: uppercase;
    height: 100%;
    display: flex;
    align-items: center;
    color: #000;
    position: absolute;
    top: 0px;
    align-items: center;
  }

  &[dir='ltr'] {
    a {
      right: 0;
    }
  }

  &[dir='rtl'] {
    a {
      letter-spacing: 0;
      left: 0;

      svg {
        transform: scaleX(-1);
        margin-left: 0 !important;
        margin-right: 8px !important;
      }
    }
  }
`;

export const InnerPageSectionHeading = styled.section`
  padding: 50px 0;
  background-color: #fff;

  &.tabsection {
    padding: 50px 0 0;
  }

  div[class*='SectionHeadlinestyled__SectionHeadline-'] {
    margin-bottom: 0;
  }

  &.award_tab {
    padding: 50px 0 0;
  }

  &.paddingtop_0 {
    padding-top: 0px;
  }

  &.padding_tab_zero {
    padding: 50px 0 0;
  }

  &.itineraries_section {
    padding: 50px 0 0;
    overflow: hidden;
    .itinerariesh2 {
      @media (min-width: 1200px) {
        margin: 0 0 2.5rem;
      }
    }
  }
`;

export const SectionExhibitor = styled.div`
  padding: 50px 0 0;

  div[class*='SectionHeadlinestyled__SectionHeadline-'] {
    margin-bottom: 0;
  }
`;

export const Section = styled.section`
  padding: 72px 0;

  @media (max-width: 767px) {
    padding: 30px 0;
  }

  &.bg_grey {
    background: #f7f7f7;
  }
`;

export const SectionServiceCard = styled.section`
  padding: 50px 0 0;
`;
